import type { FilthBackend } from "@/api/filth-backends-api"

export type FilthControlPlaneSummary = {
  totalBackends: number
  enabledBackends: number
  primaryBackends: number
  shadowBackends: number
  legacyBackends: number
}

export function summarizeFilthControlPlane(backends: FilthBackend[]): FilthControlPlaneSummary {
  return backends.reduce<FilthControlPlaneSummary>(
    (summary, backend) => {
      summary.totalBackends += 1
      if (backend.enabled) summary.enabledBackends += 1
      if (backend.consumer_mode === "primary") summary.primaryBackends += 1
      else if (backend.consumer_mode === "shadow") summary.shadowBackends += 1
      else summary.legacyBackends += 1
      return summary
    },
    {
      totalBackends: 0,
      enabledBackends: 0,
      primaryBackends: 0,
      shadowBackends: 0,
      legacyBackends: 0,
    }
  )
}
